import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import PatientList from './components/PatientList';
import PatientForm from './components/PatientForm';
import ChatInterface from './components/ChatInterface';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';

// Simple wrapper component to handle loading
function AppRoutes() {
  const { user, loading } = useAuth();
  
  // Show nothing while checking authentication
  if (loading) {
    return null; // or <div className="hidden"></div>
  }
  
  return (
    <Routes>
      <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" />} />
      <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/login" />}>
        <Route index element={<PatientList />} />
        <Route path="patients" element={<PatientList />} />
        <Route path="patients/new" element={<PatientForm />} />
        <Route path="patients/edit/:id" element={<PatientForm />} />
        <Route path="chat/:patientId" element={<ChatInterface />} />
      </Route>
      <Route path="/" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;